import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import { authActions, authSelectors } from 'state/auth';
import { useEffect } from 'react';
import { workflowActions } from 'state/workflow';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import CircleCheckIcon from 'assets/icons/CircleCheckIcon';

const SuccessComponent = ({ title }: { title: string }) => {
  useEffect(() => {
    dispatch(workflowActions.setLoading(false));
  }, []);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const identifier = location.state?.identifier;

  const token = useAppSelector(authSelectors.tokenSelector);

  const handleClick = () => {
    dispatch(authActions.logOutAndRemoveRefreshToken({ token: token }));
    navigate('/');
  };

  if (!identifier) {
    return null;
  }

  return (
    <>
      <Container
        className="bg-light-purple p-4"
        style={{ marginTop: '-1rem' }}
      >
        <Row>
          <Col>
            <p className="text-purple fw-bold m-0">SUCCESS</p>
            <h5 className="fw-bold mt-1 d-flex align-items-center gap-1">
              <CircleCheckIcon />
              {title}
            </h5>
            <p>You will be able to prescribe once your Admin has verified your approval request.</p>
          </Col>

          <Col
            className="align-items-center d-flex"
            xs={12}
            md="auto"
          >
            <Button
              variant="danger"
              className="rounded-pill px-4 fw-bold"
              onClick={handleClick}
              size="sm"
            >
              Return to Login
              <FontAwesomeIcon
                icon={faArrowRight}
                color="white"
                className="ms-1"
                size="xs"
              />
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SuccessComponent;
